import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { reduxForm, Field, change } from 'redux-form';
import { Grid } from './../../../themes/default';
import { Section, Content, Main, Buttons, FormContent, FormActions } from './../../../components/includes/container';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Upload } from './../../../components/includes/upload';
import { Ttolbar } from './../../../components/includes/ui/table';
import { SnackbarStatic } from './../../../components/includes/snackbar';
import { InputTextField, SelectField, OptionField } from './../../../components/includes/ui/input';
import { Btn } from './../../../components/includes/ui';
import { AutogestionService } from './../../../services';
import { buildSlug } from './../../../utilities/utils';

import VALIDATION from './../../../config/validation';
import API from './../../../config/api';

const validate = values => {

  const errors = {}

  if (values.status === '-1') {
    errors.status = VALIDATION.required;
  }

  if (!values.name) {
    errors.name = VALIDATION.required;
  }else if(values.name.length > 255){
    errors.name = 'El tamaño máximo es de 255 caracteres.';
  }

  return errors

};

class AutogestionCreate extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      sending: false,
      upload: false
    };
  }

  componentDidMount(){

  }

  /*
  ** @Service
  ** @Description: New
  */

  _Create = (values) => {

    AutogestionService.create(values).then((response) => {

      /**
      * @Service find all by page
      */
      this.props.history.push('/autogestion');

      /**
      * @Dispatch for alert success message
      */
      this.props.AlertShow({ open: true, variant: 'success', message: `Exito, el recurso fue creado.` });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error.data.message });

    });

  }

  handleSubmitForm = (values) => {
    this._Create(values);
  }

  /*
  ** @Service
  ** @Description: Attachments
  */

  onUploadImagen = (file) => {
    this.props.dispatch(change('AutogestionCreate', 'path', file.attachment[0] ));
  }

  /*
  ** @Event
  ** @Description: Complete slug on change name
  */

  handleOnChangeName = (e) => {
    this.props.dispatch(change('AutogestionCreate', 'slug', (buildSlug(e.target.value) )));
  }

  render() {

    const { sending } = this.state;
    const { handleSubmit, invalid } = this.props;

    return (
      <Section>
        <ToolbarPrimary title="Autogestion"/>
        <BreadcrumbItem to='/autogestion'>Autogestion</BreadcrumbItem>
        <BreadcrumbItem to='/autogestion/create'>Crear</BreadcrumbItem>
        <Content>

          <Main>

            <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>

              <Ttolbar title="Creación de recursos"/>

              <FormContent enabledActions>

                <Grid container spacing={24}>

                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SnackbarStatic
                      icon="info"
                      variant="warning"
                      message={`Formatos soportados: ${ API.upload.attachment_available_ext.join(', ') }`}
                      open={true}
                      fullWidth hideClose/>
                  </Grid>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Field
                        name="name"
                        component={ InputTextField }
                        label="Nombre"
                        type="text"
                        required
                        onChange={ this.handleOnChangeName }
                    />
                  </Grid>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Field
                        name="status"
                        component={ SelectField }
                        label="Estado" required>
                          <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                          <OptionField key="true" value="true">Activo</OptionField>
                          <OptionField key="false" value="false">Bloqueado</OptionField>
                    </Field>
                  </Grid>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Field
                        name="path"
                        type="hidden"
                        component={ InputTextField }
                    />
                    <Upload
                      button="Subir archivo"
                      onSuccess={ this.onUploadImagen.bind(this) }
                    />
                  </Grid>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Field
                        name="slug"
                        component={ InputTextField }
                        label="Slug"
                        type="text"
                        required
                    />
                  </Grid>

                </Grid>

              </FormContent>

              <FormActions>
                <Grid container>
                  <Grid item lg={6} md={6} sm={6} xs={6}>
                    <Buttons>
                      <Btn aria-label="Volver" icon="back" color="secondary" component={ NavLink } to="/autogestion">
                        Volver
                      </Btn>
                    </Buttons>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={6}>
                    <Buttons align="right">
                      <Btn aria-label="Guardar página" icon="add" color="success" type="submit" disabled={ invalid } loading={ sending }>
                        Guardar
                      </Btn>
                    </Buttons>
                  </Grid>
                </Grid>
              </FormActions>

            </form>

          </Main>

        </Content>
      </Section>
    )
  }
}

AutogestionCreate = reduxForm({
  form: 'AutogestionCreate',
  validate,
  initialValues: {
    status: '-1'
  }
})(AutogestionCreate);

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AutogestionCreate);
